import { useEffect, useState } from 'react'

import { fetchFromApi } from '@/utils/fetchFromApi.ts'

export const useMaintenanceMode = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchMaintenanceMode = async () => {
      try {
        const response = await fetchFromApi('maintenance-mode')

        if (response.ok) {
          const data = await response.json()
          setIsMaintenanceMode(data.enabled)
        }
      } catch (error) {
        console.error('Error fetching maintenance mode:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchMaintenanceMode()
  }, [])

  return {
    isLoading,
    isMaintenanceMode,
  }
}
